import { ProfileImage } from '@repo/ui/deprecated/ProfileImage';
import { themeStyle, useNewThemeActive } from '@repo/ui/theming';

import { pluralSuffix } from '../../../utils';

import AccountTag from './AccountTag';
import { ButtonWrapper, UserInfo, Title, Subtitle } from './styles';
import { AccountButtonProps } from './types';

const AccountButton: React.FC<AccountButtonProps> = (props) => {
  const profile = props.team
    ? {
        name: props.team.name,
        profileImage: props.team.profileImage,
        isTeam: true,
      }
    : (props.user ?? {});

  const handleClick = (): void => {
    if (props.onClick && !props.isActive) {
      props.onClick();
    }
  };

  const title = props.user
    ? props.user.name
    : props.team
      ? props.team.name
      : '';

  const subtitle = props.user
    ? props.user.email
    : props.team
      ? `${props.team.memberCount} member${pluralSuffix(props.team.memberCount)}`
      : '';

  const isNewThemeActive = useNewThemeActive();

  return (
    <ButtonWrapper
      isActive={props.isActive ?? false}
      isNewThemeActive={isNewThemeActive}
      onClick={handleClick}
    >
      <ProfileImage profile={profile} size="36px" />
      <UserInfo data-testid={props.isActualUser ? 'user-info' : undefined}>
        <Title noTextOverflow color={themeStyle.varInkMain}>
          {title}
        </Title>
        <Subtitle noTextOverflow color={themeStyle.varInkMedium}>
          {subtitle}
        </Subtitle>
      </UserInfo>

      <AccountTag team={props.team} user={props.user} />
    </ButtonWrapper>
  );
};

export default AccountButton;
